import React, {useEffect} from 'react';
import useModal from './useModal';
import GroupItem from './GroupItem';
import { useQuery } from '@tanstack/react-query';
import { authHeaders } from 'actions';
import axios from 'axios';
import Routes from 'utils/routes.js.erb';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

const GroupList = ({onShowLoading, onHideLoading}) => {
  const { openModal } = useModal();
  const { data, isLoading } = useQuery({
    queryKey: ['administration', 'organization', 'groups'],
    queryFn: ({ signal }) => axios.get(
      Routes.api_dashboard_administration_organizations_groups_path(),
      { headers: authHeaders(), signal }
    ).then(response => response.data),
  })

  const { data: myAccesses, isLoading: isLoadingMyAccesses } = useQuery({
    queryKey: ['administration', 'organization', 'my-accesses'],
    queryFn: ({ signal }) => axios.get(
      Routes.api_dashboard_administration_organizations_my_accesses_path(),
      { headers: authHeaders(), signal }
    ).then(response => response.data),
  })

  useEffect(() => {
    if (isLoading) {
      onShowLoading()
    } else {
      onHideLoading()
    }

    if (isLoadingMyAccesses) {
      onShowLoading()
    } else {
      onHideLoading()
    }
  }, [isLoading, isLoadingMyAccesses, onShowLoading, onHideLoading])

  return (
    <ul>
      <li>
        <div className='row-cell' style={{backgroundColor: '#f0fbff'}}>
          <span className='cell expand'>Type</span>
          <span className='cell id'>Sparkler ID</span>
          <span className='cell name'>Name</span>
        </div>
      </li>
      {(data || []).map((group, i) => <li key={group.id}><GroupItem group={group} groupIdx={i} /></li>)}
      {myAccesses && myAccesses.full_access && (
        <li className='add level1'>
          <a className='add-button' onClick={() => openModal('group')}>
            <i className="fa fa-plus-circle"></i>
            Add Group
          </a>
        </li>
      )}
    </ul>
  );
}

const mapStateToProps = () => {
  return {}
}


const mapDispatchToProps = (dispatch) => {
  return {
    onShowLoading: () => {
      dispatch(showLoading())
    },
    onHideLoading: () => {
      dispatch(hideLoading())
    },
  }
};

GroupList.propTypes = {
  onShowLoading: PropTypes.func.isRequired,
  onHideLoading: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(GroupList);
